import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import clsx from "clsx";
import CloseIcon from "core/ReusableIcons/Close";
import styles from "./Dialog.module.css";
var CloseButton = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("button", { type: "button", onClick: onClick, "aria-label": "Close", className: clsx(styles.closeButton, className), "data-testid": "dialog-close-button", children: _jsx(CloseIcon, { size: { width: 16, height: 16 }, ariaHidden: true }) }));
};
export default CloseButton;
